import LocalStorage from '../local_data';
import Event from './Event';

class ChangeLocation extends Event {
    eventName = 'oms_changeLocation';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * @event oms_changeLocation
     * Event Function for Save current location
     * 
     * @param {string} data.location_id - required - location id
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let locationId = data.location_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        if (clientId && locationId) {
            let currentLocation = new LocalStorage.CurrentLocation(clientId);
            currentLocation.setData(locationId);

            thisObj.onSuccessEvent({
                "auth_type": "public",//? 
                "data": data,
                "data_type": "local", //?
                "success" : true,//?
                "message" : ""//
            },
            {
                'action' : action, 
                'request_id' : requestId 
            });

        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "client_id & location_id is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default ChangeLocation;